// extracted by mini-css-extract-plugin
module.exports = {"btnSemiTransparent":"ButtonSemiTransparent_btnSemiTransparent__Sr9Zr"};